// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".question-label[data-v-65d59982] {\n  font-weight: 500;\n}\n.question-hint[data-v-65d59982] {\n  color: #a0a0a0;\n}\n", ""]);
// Exports
module.exports = exports;
